<template>
  <div>
    <template v-if="loader">
      <Loader />
    </template>
    <template v-if="payed">
      <div class="container-success">
        <div class="box-message">
          <h1>{{ errorMessage }}</h1>
        </div>
      </div>
    </template>
    <template v-else>
      <section class="container-payment">
        <div v-if="invoice_number">
          <div class="payment">
            <div class="logo">
              <div class="brand">
                <span>Welcome</span><br />
                <span>to easypaper</span>
              </div>
              <div class="trace"></div>
            </div>
            <div class="pay-detail">
              <div class="company">
                <h2>{{ company_name }}</h2>
              </div>
              <h4 class="title-bold">Comments:</h4>
              <div class="comment">
                <h4>{{comments}}</h4>
              </div>
              <h4 class="title-bold">Invoice: <span class="invoice">#{{invoice_number}}</span></h4>
              <div class="date">
                <h4 class="title-bold">Transaction date: <span>{{cDate}}</span></h4>
              </div>
              <h4 class="title-bold">Amount (USD)</h4>
              <div class="money">
                <h4>
                  {{amount.toLocaleString('en-CA', { style: 'currency', currency: 'USD' })}}
                </h4>
              </div>
              <div class="cut"></div>
            </div>
            <div class="pay">
              <div class="header">
                <img
                  :src="require('./../../src/assets/icons/pay.svg')"
                  alt="pay"
                >
                <h4>Credit Card Details</h4>
              </div>
              <div class="flex">
                <label for="first-name">First name on account</label>
                <input
                  autocomplete="off"
                  @click="validFirstName = false"
                  id="first-name"
                  v-model="first_name"
                  class="input-pay"
                  :class="{ 'error-input': validFirstName && first_name === '' }"
                  type="text"
                  placeholder="First name on account"
                />
                <template v-if="validFirstName && first_name === ''">
                  <span class="error-msg">
                    Field required*</span>
                </template>
              </div>
              <div class="flex">
                <label for="last-name">Last name on account</label>
                <input
                  autocomplete="off"
                  id="last-name"
                  v-model="last_name"
                  class="input-pay"
                  :class="{ 'error-input': validLastName && last_name === '' }"
                  type="text"
                  placeholder="Last name on account"
                />
                <template v-if="validLastName && last_name === ''">
                  <span class="error-msg">
                    Field required*</span>
                </template>
              </div>
              <div class="flex">
                <label for="card">Card number</label>
                <input
                  autocomplete="off"
                  v-mask="'###################'"
                  id="card"
                  v-model="number"
                  class="input-pay"
                  :class="{ 'error-input': validNumber
                  && (number.length < 12 || number.length > 19) }"
                  type="text"
                  placeholder="Card number"
                />
                <template v-if="validNumber && (number.length < 12 || number.length > 19)">
                  <span class="error-msg">
                    Field required*</span>
                </template>
              </div>
              <div class="flex">
                <label for="csv">CVV</label>
                <div class="row">
                  <input
                    autocomplete="off"
                    v-mask="'####'"
                    v-model="cvv"
                    class="input-pay csv"
                    :class="{ 'error-input': validCvv && cvv.length < 3}"
                    type="text"
                    placeholder="CVV"
                  />
                  <template v-if="validCvv && cvv.length < 3">
                    <span class="error-msg">
                      Field required*</span>
                  </template>
                  <img
                    :src="require('./../../src/assets/icons/card.svg')"
                    alt="csv-card"
                  >
                </div>
              </div>
              <div class="flex row">
                <div class="month">
                  <label for="csv">Expiration month</label>
                  <div>
                    <input
                      @click="monthYear = false"
                      autocomplete="off"
                      @change="formatMonth(), isMonthValid()"
                      v-mask="'##'"
                      min-value
                      v-model="expiry_month"
                      class="input-pay month"
                      :class="{ 'error-input': validMonth && expiry_month === '' || monthYear }"
                      type="text"
                      placeholder="Month"
                    />
                    <template v-if="validMonth && (expiry_month > 12 || expiry_month === '')">
                      <span class="error-msg">
                        Field required*</span>
                    </template>
                    <template v-if="monthYear">
                      <span class="error-msg">
                        Invalid Month*</span>
                    </template>
                  </div>
                </div>
                <div class="year">
                  <label for="csv">Expiration year</label>
                  <div>
                    <input
                      ref="year"
                      autocomplete="off"
                      @change="formatYear()"
                      v-mask="'##'"
                      v-model="expiry_year"
                      class="input-pay year"
                      :class="{ 'error-input': validYear && expiry_year === ''
                      || (isYearValid() && expiry_year.length > 0)}"
                      type="text"
                      placeholder="Year"
                    />
                    <template v-if="validYear && expiry_year === '' ">
                      <span class="error-msg">
                        Field required*</span>
                    </template>
                    <template v-if="isYearValid() && expiry_year.length > 0">
                      <span class="error-msg">
                        Invalid year*</span>
                    </template>
                  </div>
                </div>
              </div>
              <template v-if="numberError">
                <span class="card-invalid">
                  {{numberError}}*</span>
              </template>
              <button
                type="submit"
                @click.prevent="valid()"
                class="btn-login green"
              >
                <template v-if="loaderButton">
                  <LoaderButton />
                </template>
                <template v-else>
                  Pay
                </template>
              </button>
            </div>
          </div>

        </div>
      </section>
    </template>
  </div>
</template>
<style lang="scss" scoped></style>
<script>
import Loader from '@/components/Loader/Loader.vue';
import LoaderButton from '@/components/Loader/LoaderButton.vue';
import Moment from 'moment';

export default {
  name: 'Payment',
  data() {
    return {
      year: Moment(new Date()).format('yy'),
      month: Moment(new Date()).format('MM'),
      loader: false,
      loaderButton: false,
      payed: '',
      paymentRequestId: '',
      company_name: '',
      invoice_number: '',
      amount: '',
      transaction_date: '',
      comments: '',
      first_name: '',
      last_name: '',
      number: '',
      numberError: '',
      cvv: '',
      expiry_month: '',
      expiry_year: '',
      monthYear: false,
      validFirstName: false,
      validLastName: false,
      validNumber: false,
      validCvv: false,
      validMonth: false,
      validYear: false,
      validMonthYear: false,
      errorMessage: '',
      successMessage: '',
      generatedLink: '',
    };
  },
  components: {
    Loader,
    LoaderButton,
  },
  mounted() {
    this.loadPaymentRequest();
    this.year = this.year.slice(2);
  },
  computed: {
    cDate() {
      return Moment(this.transaction_date).format('MM/DD/YYYY');
    },
  },
  methods: {
    formatMonth() {
      this.expiry_month = this.expiry_month.padStart(2, '0');
    },
    formatYear() {
      this.expiry_year = this.expiry_year.padStart(2, '0');
    },
    isMonthValid() {
      const now = Moment(new Date()).format('MM');
      if (Number(this.expiry_month) < Number(now) || Number(this.expiry_month > 12)) {
        return true;
      }
      this.$refs.year.focus();
      return false;
    },
    isYearValid() {
      const now = Moment(new Date()).format('YY');
      return Number(this.expiry_year) < Number(now);
    },
    isYearActual() {
      const now = Moment(new Date()).format('YY');
      return Number(this.expiry_year) === Number(now);
    },
    validYearAndMont() {
      this.monthYear = this.isYearActual() && this.isMonthValid();
    },
    async loadPaymentRequest() {
      this.loader = true;
      this.paymentRequestId = this.$route.params.id;
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      };
      fetch(`${process.env.VUE_APP_API_URL}/v1/find/${this.paymentRequestId}`, requestOptions)
        .then(async (response) => {
          const data = await response.json();
          this.payed = data.error;

          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.error) || response.status;
            this.loader = false;
            return Promise.reject(error);
          }
          if (data.transaction) {
            const importjson = JSON.parse(data.transaction.json_import);
            if (!importjson) {
              this.amount = data.transaction.amount;
            } else {
              this.amount = importjson.total_due;
            }
            this.company_name = data.transaction.company_name;
            this.invoice_number = data.transaction.invoice_number;
            this.transaction_date = data.transaction.transaction_date;
            this.comments = data.transaction.comment;
          }
          this.loader = false;
          return true;
        })
        .catch((error) => {
          this.loader = false;
          this.errorMessage = error;
        });
    },
    valid() {
      this.validYearAndMont();
      if (!this.first_name) {
        this.validFirstName = true;
      }
      if (!this.last_name) {
        this.validLastName = true;
      }
      if (!this.number || this.number.length < 12 || this.number.length > 19) {
        this.validNumber = true;
      }
      if (!this.cvv.length || this.cvv.length < 3) {
        this.validCvv = true;
      }
      if (!this.expiry_month || this.expiry_month > 12 || this.expiry_month < this.month) {
        this.validMonth = true;
      }
      if (!this.expiry_year || this.expiry_year < this.year) {
        this.validYear = true;
      }

      if (this.first_name
        && this.last_name
        && this.number && this.number.length > 11 && this.number.length < 20
        && this.cvv.length >= 3
        && this.month < 13
        && !this.isYearValid()
        && !this.monthYear
      ) {
        this.pay();
      }
    },
    async pay() {
      this.loaderButton = true;
      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          first_name: this.first_name,
          last_name: this.last_name,
          number: this.number,
          cvv: this.cvv,
          expiry_month: this.expiry_month,
          expiry_year: this.expiry_year,
        }),
      };
      fetch(`${process.env.VUE_APP_API_URL}/v1/update/${this.paymentRequestId}`, requestOptions)
        .then(async (response) => {
          const data = await response.json();
          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            const error = (data && data.error) || response.status;
            this.numberError = error;
            this.loaderButton = false;
            return Promise.reject(error);
          }
          this.company_name = '';
          this.invoice_number = '';
          this.amount = '';
          this.transaction_date = '';
          this.comments = '';
          this.first_name = '';
          this.last_name = '';
          this.number = '';
          this.cvv = '';
          this.expiry_month = '';
          this.expiry_year = '';
          this.validFirstName = false;
          this.validLastName = false;
          this.validNumber = false;
          this.validCvv = false;
          this.validMonth = false;
          this.validYear = false;
          this.invoice_number = '';
          this.successMessage = 'Payment made';
          this.loaderButton = false;
          const importjson = JSON.parse(data.transaction.json_import);
          if (!importjson) {
            localStorage.setItem('amount', data.transaction.amount.toLocaleString('en-CA', { style: 'currency', currency: 'USD' }));
          } else {
            localStorage.setItem('amount', importjson.total_due.toLocaleString('en-CA', { style: 'currency', currency: 'USD' }));
          }
          localStorage.setItem('invoice_number', data.transaction.invoice_number);
          localStorage.setItem('updated_at', data.transaction.updated_at);
          localStorage.setItem('id', data.transaction.id);
          this.$router.push({
            path: `/success/${data.transaction.reference}`,
          });
          return false;
        })
        .catch((error) => {
          this.loaderButton = false;
          this.errorMessage = error;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.csv {
  max-width: 193px;
}
.month,
.year {
  position: relative;
  padding-top: 41px;
}
.month {
  max-width: 164px;
  margin-right: 35px;
}
.year {
  max-width: 143px;
  .error-msg {
    margin-left: -143px;
  }
}

.row {
  flex-direction: row !important;
  margin: 0;
  img {
    margin-left: 16px;
  }
}
.container-payment {
  display: flex;
  min-height: 100vh;
  justify-content: center;
  padding: 54px 43px 49px 33px;
  background-image: url("../../src/assets/background/background-pay.svg");
  background-size: cover;
  @media (max-width: 1300px) {
    padding: 1rem;
    background-image: none;
    background-color: $backgroundData;
  }
  .payment {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    @media (max-width: 1300px) {
      flex-direction: column;
    }
    .pay {
      position: relative;
      display: flex;
      flex-direction: column;
      width: 389px;
      height: auto;
      padding: 13px 20px 20px 22px;
      background: #ffffff;
      box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.25);
      border-radius: 5px;
      margin-left: 24px;
      @media (max-width: 1300px) {
        justify-content: center;
        margin: 0 auto;
        margin-top: 10px;
      }
      .flex {
        display: flex;
        flex-direction: column;
        position: relative;
        text-align: left;
        label {
          margin-top: 25px;
          font-weight: 500;
          font-size: 16.0015px;
          color: $header;
        }
        input {
          border: 1.00009px solid #b0bac9;
          border-radius: 5px;
          padding: 8px;
          font-size: 12px;
          outline: none;
        }
      }
      .header {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        h4 {
          margin-left: 15px;
          font-weight: 500;
          font-size: 20px;
          color: $header;
        }
      }
    }
    .logo {
      margin-top: 98px;
      margin-right: 80px;
      @media (max-width: 1300px) {
        display: none;
      }
      .brand {
        max-width: 380px;
        text-align: left;
        span {
          font-size: 50.1707px;
          color: $white;
          font-weight: bold;
          line-height: 61px;
        }
      }
      .trace {
        width: 85px;
        height: 5px;
        margin-top: 46px;
        background-color: $primary;
        border-radius: 21px;
      }
    }
    .pay-detail {
      position: relative;
      display: flex;
      align-self: flex-start;
      flex-direction: column;
      // width: 100%;
      width: 389px;
      padding: 17px 46px 15px 28px;
      background: #ffffff;
      box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.25);
      border-radius: 5px 5px 0 0;
      @media (max-width: 1300px) {
          margin: 0 auto;
      }
      .comment {
        text-align: left;
        font-weight: normal;
        font-size: 14px;
        margin-top: -7px;
        word-break: break-word;
      }
      .cut {
        width: 100%;
        position: absolute;
        height: 31px;
        // max-width: 389px;
        background-image: url("../../src/assets/background/cut.svg");
        bottom: 0;
        left: 0;
        margin-bottom: -17px;
        @media (max-width: 1300px) {
          background-image: url("../../src/assets/background/cutGrey.svg");
        }
      }
    }
  }
}
h4,
h2 {
  text-align: left;
}
.company {
  h2 {
    line-height: 120%;
    font-weight: 500;
    font-size: 34px;
    color: $header;
  }
}
.title-bold {
  font-weight: bold;
  font-size: 14px;
  color: $header;
  margin-top: 9px;
}
.comment {
  max-width: 315px;
  line-height: 120%;
  h4 {
    margin-top: 5px !important;
  }
}
.invoice,
.comment,
.date,
.money {
  font-size: 14px;
  color: $header;
}
.date {
  span {
    font-weight: normal;
  }
}
.invoice {
  font-weight: normal;
}
.money {
  h4 {
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 10px;
    color: #287d3c;
  }
}
.container-success {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: url("../../src/assets/background/background-pay.svg");
  background-size: cover;
  .box-message {
    display: flex;
    align-items: center;
    padding: 25px;
    width: 50vw;
    height: 40vh;
    background-color: $white;
    border-radius: 10px;
    h1 {
      font-size: 36px;
      color: $header;
      margin-bottom: 5px;
    }
    span {
      padding: 0.5rem 0.8rem;
      font-size: 24px;
      color: $payed;
      background-color: $backgroundPayed;
      border-radius: 96px;
    }
    @media (max-width: 900px) {
      width: 90vw;
      h1 {
        margin-bottom: 15px;
      }
    }
  }
}
</style>
